import { useState } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { makeStore } from '@/store';

import { AppErrorBoundary } from './AppErrorBoundary';
import { buildRouter } from './router/buildRouter';

export function App() {
  // Created once per app mount (not at module scope) so tests get fresh instances.
  const [store] = useState(makeStore);
  const [router] = useState(buildRouter);
  return (
    <AppErrorBoundary>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </AppErrorBoundary>
  );
}
